const guideGen3 = [
  "Wurzelheim – Starter auswählen",
  "Route 101 – erstes Pokémon begegnen",
  "Rosaltstadt – Pokémon fangen lernen",
  "Route 102 – erster Trainerkampf",
  "Blütenburg City – Besuch bei Norman",
  "Route 104 & Blütenburgwald durchqueren",
  "Metarost City – 1. Arena (Gestein)",
  "Devon-Mitarbeiter retten in Route 116 & Metaflurtunnel",
  "Faustauhaven – 2. Arena (Kampf)",
  "Granithöhle – Brief an Troy überbringen",
  "Graphitport City – Devon-Mitarbeiter & Team Magma/Aqua",
  "Route 110 – Kampf gegen Rivalen",
  "Malvenfroh City – 3. Arena (Elektro)",
  "Route 111 & Fiery Path",
  "Laubwechselfeld – 4. Arena (Feuer)",
  "Route 113 – Ascheweg",
  "Fallarbor City – Meteoriten-Event",
  "Meteor-Fälle – Team Magma/Aqua",
  "Route 114 zurück & Storyfortschritt",
  "Seegrasulb City – 5. Arena (Normal)",
  "Wetter-Institut & Rivalenkampf",
  "Baumhausen City – 6. Arena (Flug)",
  "Route 120 – Begegnung mit Troy & Devon-Scanner",
  "Pyroberg – Story mit Team Magma/Aqua",
  "Route 122 – Pyroberg-Gipfel",
  "Moosbach City – 7. Arena (Psycho)",
  "Versteck von Team Magma/Aqua",
  "Route 128 – Eingang zur Urzeithöhle",
  "Urzeithöhle – Kyogre/Groudon stoppen",
  "Xeneroville – 8. Arena (Wasser)",
  "Siegesstraße vorbereiten",
  "Route 129–130 – Pokémon-Liga",
  "Top 4 & Champ",
];

export default guideGen3;
